import { useGetMeReferralCode } from '@/lib/hooks/services/useGetMeReferralCode'
import { copyTextToClipboard } from '@/lib/utils/shared/copyTextToClipboard'
import { useRouter } from 'next/router'
import { toast } from 'sonner'

type CopyReferralLinkParams = {
  type: 'standard' | 'focus'
}

export const useCopyReferralLink = () => {
  const { query } = useRouter()
  const { referralCode } = useGetMeReferralCode()

  const copyReferralLink = ({ type }: CopyReferralLinkParams) => {
    const productId = query.productId as string
    const sku = query.sku as string

    const baseUrl = `${window.location.origin}/product/${productId}`
    const params = new URLSearchParams({
      sku,
      referralCode: referralCode || '',
      ...(type === 'focus' && { focus: 'true' }),
    })
    const shareUrl = `${baseUrl}?${params}`

    copyTextToClipboard({ text: shareUrl })

    toast.success('Link copied to clipboard!')

    return shareUrl
  }

  return { copyReferralLink }
}
